import React from "react";
import numberbeautify from "../../utils/numberbeautify";
import money_rounding from "../../utils/money_rounding";
import { FiCreditCard, FiDollarSign, FiPackage, FiRefreshCw, FiTrendingDown } from "react-icons/fi";
import {
    CartesianGrid,
    Legend,
    Line,
    LineChart,
    ResponsiveContainer,
    Tooltip,
    XAxis,
    YAxis,
} from "recharts";

const Customersummary = ({total_sold, total_sold_in_loan, total_profit, total_sold_lose, total_losed, total_loan_in, data}) => {
    const amount = value => Number(value) || 0;
    const money = value => `$${numberbeautify(money_rounding(amount(value)))}`;
    const chartData = [
        { id:0, month: "09/2025", total_sold: 4200, total_profit: 1250, total_sold_in_loan:2000 , total_sold_lose:0 , total_losed:0 , total_loan_in:700},
        { id:1, month: "12/2025", total_sold: 5100, total_profit: 1680, total_sold_in_loan:3500 , total_sold_lose:0 , total_losed:0 , total_loan_in:400},
        { id:2, month: "02/2026", total_sold: 4700, total_profit: 1420, total_sold_in_loan:700 , total_sold_lose:200 , total_losed:70 , total_loan_in:1200},
        { id:3, month: "03/2026", total_sold: 6350, total_profit: 2240, total_sold_in_loan:2800 , total_sold_lose:150 , total_losed:40 , total_loan_in:600},
        { id:4, month: "05/2026", total_sold: 5900, total_profit: 2060, total_sold_in_loan:300 , total_sold_lose:80 , total_losed:10 , total_loan_in:100},
        { id:5, month: "07/2026", total_sold: 7600, total_profit: 2810, total_sold_in_loan:800 , total_sold_lose:170 , total_losed:50 , total_loan_in:3000},
    ];
    const chartMoney = value => `${money(value)}`;
    const chartSeries = [
        { key: "total_sold", label: "1. فرۆش", color: "#6366f1" },
        { key: "total_profit", label: "2. قازانج", color: "#10b981" },
        { key: "total_loan_in", label: "3. قەرزی گەڕاوە", color: "#0285c7" },
        { key: "total_sold_lose", label: "4. فرۆش (زەرەر)", color: "#d97706" },
        { key: "total_losed", label: "5. بڕی زەرەر", color: "#ff1d46" },
    ];
    const ChartTooltip = ({ active, payload, label }) => {
        if (!active || !payload?.length) return null;

        const rankedPayload = [...payload].sort((first, second) => (
            chartSeries.findIndex((series) => series.key === first.dataKey) -
            chartSeries.findIndex((series) => series.key === second.dataKey)
        ));

        return (
            <div className="min-w-[180px] rounded-xl border border-slate-200 bg-white p-3 text-right shadow-lg" dir="rtl">
                <p className="mb-2 border-b border-slate-100 pb-2 text-xs font-bold text-slate-700">{label}</p>
                <div className="space-y-2">
                    {rankedPayload.map((entry) => {
                        const series = chartSeries.find((item) => item.key === entry.dataKey);
                        return (
                            <div key={entry.dataKey} className="flex items-center justify-between gap-4 text-xs">
                                <span className="flex items-center gap-1.5 font-medium text-slate-600">
                                    <span className="h-2 w-2 rounded-full" style={{ backgroundColor: series.color }} />
                                    {series.label}
                                </span>
                                <span className="font-bold text-slate-800" dir="ltr">{chartMoney(entry.value)}</span>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    };
    const ChartLegend = () => (
        <div className="flex flex-wrap justify-start gap-x-5 gap-y-2 px-2 pt-4 text-right" dir="rtl">
            {chartSeries.map((series) => (
                <div key={series.key} className="flex items-center gap-2 text-xs font-medium text-slate-600">
                    <span className="h-2.5 w-2.5 rounded-full" style={{ backgroundColor: series.color }} />
                    <span>{series.label}</span>
                </div>
            ))}
        </div>
    );

    const Metric = ({ icon: Icon, label, value, tone = "slate", detail }) => (
        <div className="flex items-center justify-between gap-4 rounded-xl border border-slate-100 bg-white p-4 shadow-sm">
            <div className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-lg ${tone === "green" ? "bg-emerald-50 text-[#10b981]" : tone === "red" ? "bg-rose-50 text-rose-600" : tone === "indigo" ? "bg-indigo-50 text-indigo-600" : tone === "yellow" ? "bg-amber-50 text-amber-600" : tone === "blue" ? "bg-sky-50 text-sky-600" :"bg-slate-100 text-slate-500"}`}>
                <Icon size={19} />
            </div>
            <div className="min-w-0 flex-1 text-right">
                <p className="text-sm font-medium text-slate-400">{label}</p>
                <p className="mt-1 text-sm font-semibold text-slate-800">{value}</p>
                {detail && <p className="mt-1 text-xs text-slate-400">{detail}</p>}
            </div>
        </div>
    );

    return (
        <div className="space-y-6" dir="rtl">
            <div className="grid grid-cols-1 gap-2 sm:grid-cols-2 xl:grid-cols-5">
                <Metric icon={FiPackage} label="کۆی فرۆشی کاڵا" value={money(total_sold)} tone="indigo"/>
                <Metric icon={FiDollarSign} label="کۆی قازانج" value={money(total_profit)} tone="green" />
                <Metric icon={FiCreditCard} label="کۆی فرۆش بە قەرز" value={money(total_sold_in_loan)} tone="yellow" />
                <Metric icon={FiRefreshCw} label="کۆی قەرزی گەڕاوە" value={money(total_loan_in)} tone="blue" />
                <Metric icon={FiTrendingDown} label="کۆی فرۆش (زەرەر)" value={money(total_sold_lose)} tone="red" detail={`بڕی زەرەر (${money(total_losed)})`} />
            </div>

            <section className="overflow-hidden rounded-2xl border border-slate-100 bg-white shadow-sm">
                <div className="flex flex-col gap-3 border-b border-slate-100 px-5 py-5 sm:flex-row sm:items-center sm:justify-between sm:px-6">
                    <div>
                        <div className="flex items-center gap-2">
                            <span className="h-2 w-2 rounded-full bg-indigo-500" />
                            <p className="text-xs font-medium text-indigo-500">نموونەی بینین</p>
                        </div>
                        <h2 className="mt-1 text-lg font-bold text-slate-800">گرافیکی قازانج و زەرەر</h2>
                        <p className="mt-1 text-xs text-slate-400">پیشاندانی داتا شێوەی گرافەک</p>
                    </div>
                    <div className="rounded-xl bg-slate-50 px-4 py-3 text-right">
                        <p className="text-xs text-slate-400">باشترین مانگ</p>
                        <p className="mt-1 text-sm font-bold text-slate-700">07/2026 <span className="font-normal text-slate-400">/ فرۆشتن</span></p>
                    </div>
                </div>

                <div className="grid p-4 sm:p-6 lg:items-center">
                    <div className="h-[340px] w-full min-w-0" dir="ltr">
                        <ResponsiveContainer width="100%" height="100%">
                            <LineChart data={data} margin={{ top: 12, right: 8, left: 0, bottom: 4 }}>
                                <CartesianGrid stroke="#e2e8f0" strokeDasharray="4 4" vertical={false} />
                                <XAxis dataKey="month" axisLine={false} tickLine={false} tick={{ fill: "#94a3b8", fontSize: 10 }} dy={10} />
                                <YAxis axisLine={false} tickLine={false} tick={{ fill: "#94a3b8", fontSize: 10 }} tickFormatter={(value) => `${numberbeautify(money(value))}`} width={64} />
                                <Tooltip cursor={{ stroke: "#cbd5e1", strokeDasharray: "4 4" }} content={<ChartTooltip />} />
                                {chartSeries.map((series) => (
                                    <Line key={series.key} type="monotone" dataKey={series.key} stroke={series.color} strokeWidth={2} dot={{ r: 4, fill: series.color, strokeWidth: 2, stroke: "#fff" }} activeDot={{ r: 6, strokeWidth: 3, stroke: "#fff" }} />
                                ))}
                                <Legend verticalAlign="bottom" align="right" height={54} content={<ChartLegend />} />
                            </LineChart>
                        </ResponsiveContainer>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Customersummary